import { type FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { getImage } from '@common/lib/images';
import { H1 } from '@components/Typography/Typography';
import { MainButton } from '@components/ui/Button/Button';
import { Picture } from '@components/ui/Picture/Picture';
import { ProductionRecipe } from '@components/Workshop/ProductionRecipe/PruductionRecipe';
import { selectLastProductDataByWorkshopId } from '@redux/selectors/workshopSelectors';

import { divide } from '@/common/lib/decimal';
import ContractBackground from '@/components/common/ContractBackground/ContractBackground';
import { selectProductOfDayByGoodsType } from '@/redux/selectors/contractSelectors';
import { useAppSelector } from '@/redux/store';

import { ModalContext } from '../Modal/config';

import css from './styles.module.scss';

interface OpenNewGoodsProps {
  id: string;
}

const OpenNewGoodsModal: FC<OpenNewGoodsProps> = ({ id }) => {
  const { t } = useTranslation();
  const product = useAppSelector((state) =>
    selectLastProductDataByWorkshopId(state, id),
  );
  const productOfDay = useAppSelector((state) =>
    selectProductOfDayByGoodsType(state, product?.name as string),
  );
  const { closeModal } = useContext(ModalContext);

  if (!product) {
    return null;
  }

  const icon = getImage({ name: product.name, field: 'icons' });

  return (
    <div className="h-[54vh] max-h-[500px] min-h-[466px] relative flex flex-col">
      <div className={css.background}></div>
      <div className="w-full h-full px-4 pb-10 flex flex-col items-center isolate">
        <div className="w-40 h-40 relative">
          {productOfDay && (
            <ContractBackground
              type={productOfDay.type === 'premium' ? 'purple' : 'green'}
            />
          )}
          <Picture
            className="size-full block"
            img={icon?.img}
            webp={icon?.webp}
            alt={product.name}
          />
        </div>
        <div className="titleNewGoods">
          <H1>{t('Congratulations!')}</H1>
          <span>{t('You ve discovered a new product.')}</span>
        </div>
        <div className="factory_body_cash_time newGoods_cash_time mb-6">
          <span>
            <img src="/img/icons/cash.png" width={24} alt="" />
            {product.costPerUnit}
          </span>
          <span>
            <img src="/img/icons/timer.png" width={24} alt="" />
            {`${divide(3600, product.productionRate).toFixed(2)} sec`}
          </span>
        </div>
        <ProductionRecipe workshopId={id} goodsName={product.name} />
        <MainButton
          className="min-h-12 mt-10"
          onClick={closeModal}
          text={t('OK')}
        />
      </div>
    </div>
  );
};

export default OpenNewGoodsModal;
